// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2KK9R","actions":"GroupTable_actions__2EGAm","deleteModalFooter":"GroupTable_deleteModalFooter__2Q0SX"};